<template>
  <section
    class="region-selector"
    :class="{ drawer }"
    role="dialog"
    aria-label="区域选择"
    :aria-modal="drawer ? 'true' : null"
    tabindex="-1"
    ref="panel"
    @keydown="onKeydown"
  >
    <header>
      <button v-if="!drawer" class="control-link" @click="returnToRegion">返回</button>
      <h2>区域选择</h2>
      <button class="control-link manage-region" aria-label="区域管理" @click="$emit('manage')">
        <img src="~assets/img/controlpublic/shezhi_lan.png" alt="" />
      </button>
    </header>
    <div class="selector-list" @scroll.passive="onScroll">
      <h3>收藏的区域</h3>
      <button
        v-for="region in cache.followRegionList"
        :key="'follow:' + region.regionId"
        :title="region.regionName"
        @click="select(region)"
      >
        {{ region.regionName }}
        <span>›</span>
      </button>
      <p v-if="!cache.followRegionList.length">还没有收藏的区域</p>
      <h3>全部的区域</h3>
      <button
        v-for="region in cache.regionList"
        :key="region.regionId"
        :title="region.regionName"
        @click="select(region)"
      >
        {{ region.regionName }}
        <span>›</span>
      </button>
      <button @click="select({ regionId: '', regionName: '全部区域' })">
        全部区域
        <span>›</span>
      </button>
      <button v-if="cache.hasMore" :disabled="cache.loading" @click="loadMore">
        {{ cache.loading ? '正在加载更多区域...' : '加载更多区域' }}
      </button>
      <p v-if="cache.initialized && !cache.loading && !cache.hasMore">已加载全部区域</p>
    </div>
  </section>
</template>
<script>
import {
  ensureRegionNavigationScope,
  requestNextRegionNavigationPage
} from '@/common/region-navigation-data'
export default {
  props: { drawer: Boolean },
  computed: {
    cache() {
      return this.$store.state.regionnavigation
    }
  },
  mounted() {
    if (this.drawer) this.$nextTick(() => this.$refs.panel.focus())
  },
  created() {
    ensureRegionNavigationScope(this)
    requestNextRegionNavigationPage(this, { reset: true }).catch(e =>
      this.$showTipsToast(3, (e && e.message) || '获取区域失败', true, 3000)
    )
  },
  methods: {
    onKeydown(event) {
      if (!this.drawer) return
      if (event.key === 'Escape') {
        event.stopPropagation()
        this.$emit('close')
        return
      }
      if (event.key !== 'Tab') return
      const buttons = Array.from(this.$refs.panel.querySelectorAll('button:not([disabled])'))
      const first = buttons[0],
        last = buttons[buttons.length - 1]
      if (
        event.shiftKey &&
        (document.activeElement === first || document.activeElement === this.$refs.panel)
      ) {
        event.preventDefault()
        last && last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first && first.focus()
      }
    },
    returnToRegion() {
      this.$router.replace('/controlpage/region')
    },
    select(region) {
      if (this.drawer) this.$emit('select', region)
      else {
        this.$store.dispatch('asyUpdataRegionShowPage', region)
        this.returnToRegion()
      }
    },
    loadMore() {
      requestNextRegionNavigationPage(this).catch(e =>
        this.$showTipsToast(3, (e && e.message) || '获取区域失败', true, 3000)
      )
    },
    onScroll(e) {
      const el = e.target
      if (el.scrollHeight - el.scrollTop - el.clientHeight < 300) this.loadMore()
    }
  }
}
</script>
<style scoped>
.region-selector {
  max-width: 1200px;
  margin: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  box-sizing: border-box;
  color: #334155;
}
.region-selector header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 60px;
  flex: none;
}
.region-selector h2 {
  font-size: 19px;
}
.selector-list {
  flex: 1;
  overflow: auto;
  padding-bottom: 70px;
}
.selector-list h3 {
  font-size: 15px;
  margin: 16px 0;
}
.selector-list button {
  display: block;
  width: 100%;
  position: relative;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 0;
  border-bottom: 1px solid #b9b9bb;
  background: transparent;
  color: inherit;
  font: inherit;
  border-radius: 0;
  padding: 16px 40px 16px 16px;
  margin: 0;
  cursor: pointer;
}
.selector-list button span {
  position: absolute;
  right: 16px;
}
.selector-list p {
  font-size: 14px;
  color: #718094;
}
</style>

<style scoped>
.region-selector.drawer {
  width: min(72vw, 360px);
  max-width: 100%;
  margin: 0;
  background: #f2f2f2;
  padding: 0 12px;
  color: #282828;
  box-shadow: 8px 0 32px #0002;
  animation: region-drawer-in 0.18s ease-out;
}
.drawer header {
  height: 70px;
  gap: 8px;
}
.drawer h2 {
  font-size: 21px;
  font-weight: 400;
}
.drawer .selector-list {
  padding-bottom: 24px;
  scrollbar-width: none;
}
.drawer .selector-list::-webkit-scrollbar {
  display: none;
}
.drawer .selector-list h3 {
  font-size: 15px;
  font-weight: 400;
  color: #999;
  margin: 12px 0 2px;
}
.drawer .selector-list button {
  font-size: 16px;
  line-height: 24px;
  padding: 17px 24px 17px 0;
}
.drawer .selector-list button span {
  font-size: 25px;
  right: 4px;
  font-weight: 300;
  color: #aaa;
}
.manage-region {
  font-size: 27px;
  padding: 0 4px;
  color: #42b9f5;
}
@keyframes region-drawer-in {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>

<style scoped>
.manage-region img {
  width: 24px;
  height: 24px;
  display: block;
}
.region-selector:focus {
  outline: none;
}
</style>
